import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fieldDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showDescription: {
		id: 'jql-builder-basic.common.field-description-popup.show-description',
		defaultMessage: 'Show the description for this field',
		description:
			'tooltip text explaining the field description will be shown when interacting with the wrapped field description popup button',
	},
	hideDescription: {
		id: 'jql-builder-basic.common.field-description-popup.hide-description',
		defaultMessage: 'Hide the description for this field',
		description: 'inform users that they can close the pop up',
	},
	fieldDescription: {
		id: 'jql-builder-basic.common.field-description-popup.field-description',
		defaultMessage: 'Field description',
		description:
			'aria-label for the field description popup button that includes the specific field name for better accessibility',
	},
});

export default messages;
